// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Contravariant_Compat from "../Data.Functor.Contravariant.Compat/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var mkCallback = /* #__PURE__ */ Specular_Callback.mkCallback();
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var triggerCallback = /* #__PURE__ */ Specular_Callback.triggerCallback();
var contramapCallbackDyn = /* #__PURE__ */ Specular_Callback.contramapCallbackDyn();
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var refUpdate = /* #__PURE__ */ Specular_Ref.refUpdate(Effect_Class.monadEffectEffect);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var elem = /* #__PURE__ */ Data_Foldable.elem(Data_Foldable.foldableArray);
var MultiChoiceRef = function (x) {
    return x;
};
var toggleSelectionStatus = function (v) {
    return new Specular_Ref.Ref(v.selected, mkCallback(function (f) {
        return function __do() {
            var old = readDynamic(v.selected)();
            var value = f(old);
            return Data_Function.flip(triggerCallback)(Data_Unit.unit)((function () {
                if (value) {
                    return v.select;
                };
                return v.deselect;
            })())();
        };
    }));
};
var makeMultiChoiceRef = function (dictEq) {
    var eq = Data_Eq.eq(Data_Eq.eqArray(dictEq));
    var difference = Data_Array.difference(dictEq);
    return function (choices_) {
        return function (ref) {
            var ensureValid = function (choices$prime) {
                return function (old) {
                    return function ($$new) {
                        if (eq(difference($$new)(choices$prime))([  ])) {
                            return $$new;
                        };
                        if (Data_Boolean.otherwise) {
                            return old;
                        };
                        throw new Error("Failed pattern match at Specular.MultiChoiceRef (line 43, column 5 - line 45, column 24): " + [ choices$prime.constructor.name, old.constructor.name, $$new.constructor.name ]);
                    };
                };
            };
            return {
                choices: choices_,
                currentChoices: new Specular_Ref.Ref(Specular_Ref.refValue(ref), contramapCallbackDyn(mapFlipped(choices_)(function (choices$prime) {
                    return function (updateFn) {
                        return function (old) {
                            return ensureValid(choices$prime)(old)(updateFn(old));
                        };
                    };
                }))(refUpdate(ref)))
            };
        };
    };
};
var newMultiChoiceRef = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var bind1 = Control_Bind.bind(Monad0.Bind1());
    var newRef = Specular_Ref.newRef(dictMonadEffect);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictEq) {
        var makeMultiChoiceRef1 = makeMultiChoiceRef(dictEq);
        return function (choices_) {
            return function (initial) {
                return bind1(newRef(initial))(function (ref) {
                    return pure(makeMultiChoiceRef1(choices_)(ref));
                });
            };
        };
    };
};
var currentChoices = function (v) {
    return v.currentChoices;
};
var choices = function (v) {
    return v.choices;
};
var withSelectionStatus = function (dictEq) {
    var elem1 = elem(dictEq);
    var $$delete = Data_Array["delete"](dictEq);
    return function (cref) {
        return map(map1(function (x) {
            return {
                value: x,
                selected: map(elem1(x))(Specular_Ref.refValue(currentChoices(cref))),
                select: Data_Functor_Contravariant_Compat.cvoidRight(Data_Array.cons(x))(refUpdate(currentChoices(cref))),
                deselect: Data_Functor_Contravariant_Compat.cvoidRight($$delete(x))(refUpdate(currentChoices(cref)))
            };
        }))(choices(cref));
    };
};
export {
    MultiChoiceRef,
    newMultiChoiceRef,
    makeMultiChoiceRef,
    choices,
    currentChoices,
    withSelectionStatus,
    toggleSelectionStatus
};
